import React from 'react';
import { PeekStack, PeekSlider, PeekBox, PeekIconButton, PeekTypography } from '@piiqtechnologies/ui-components';
import { ZoomOut, ZoomIn } from '@piiqtechnologies/svg-icons';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';

const ZoomCtrl = ({ icon, onClick }) => (React.createElement(PeekBox, null,
    React.createElement(PeekIconButton, { onClick: onClick, color: "primary", bordered: false },
        React.createElement(PeekTypography, { fontWeight: "fontWeightBold", fontSize: 22 }, icon))));
const MAX_ZOOM = 120;
const MIN_ZOOM = 50;
const HfovSlider = () => {
    const { setHfov: setPannellumHfov } = usePannellumViewer();
    const [hfov, setHfov] = React.useState((document.documentElement.clientWidth < document.documentElement.clientHeight && 80) || 115);
    const handleSliderChange = (event, newHfov, activeThumb) => {
        setHfov(newHfov);
        setPannellumHfov(newHfov);
    };
    const onZoomClick = (key) => {
        let newHfov;
        if (key === "in" && hfov < MAX_ZOOM) {
            newHfov = hfov + 5;
        }
        else if (key === "out" && hfov > MIN_ZOOM) {
            newHfov = hfov - 5;
        }
        if (newHfov) {
            setHfov(newHfov);
            setPannellumHfov(newHfov);
        }
    };
    return (React.createElement(PeekStack, { bgcolor: "text.secondary", sx: { px: 0.5, borderRadius: 10 }, height: "100%", alignItems: "center", direction: "column", spacing: 1 },
        React.createElement(ZoomCtrl, { icon: React.createElement(ZoomOut, null), onClick: () => onZoomClick("in") }),
        React.createElement(PeekSlider, { orientation: "vertical", sx: { p: 0, width: "auto !important", height: "100% !important" }, step: 5, max: MAX_ZOOM, min: MIN_ZOOM, "aria-labelledby": "discrete-slider-always", marks: true, value: hfov, onChange: handleSliderChange }),
        React.createElement(ZoomCtrl, { icon: React.createElement(ZoomIn, null), onClick: () => onZoomClick("out") })));
};

export { HfovSlider, HfovSlider as default };
